import { render, staticRenderFns } from "./CreateAcountPhone.vue?vue&type=template&id=ec90bcd8&scoped=true"
import script from "./CreateAcountPhone.vue?vue&type=script&lang=js"
export * from "./CreateAcountPhone.vue?vue&type=script&lang=js"
import style0 from "./CreateAcountPhone.vue?vue&type=style&index=0&id=ec90bcd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec90bcd8",
  null
  
)

export default component.exports